<template>
  <div>
    <section v-if="!mobile">
      <section v-if="bannerMatchEventDetail === 'default'">
        <v-row
          class="event-card-intro no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundPath +
            object.sport.id +
            '.webp\');height: 90px;background-size: cover;'
          "
          v-if="object.event.type == 'match'"
        >
          <v-col
            cols="12"
            sm="5"
            md="5"
            class="no-padding align-middle flex-end"
          >
            <div class="competitor">
              <!--              <div class="flag" :title="object.event.competitors.home.name">-->
              <!--                <img :src="flagTeamsPath+object.event.competitors.home.id+'.png'"-->
              <!--                     :alt="object.event.competitors.home.name">-->
              <!--              </div>-->
              <div class="name">{{ object.event.competitors.home.name }}</div>
            </div>
          </v-col>

          <v-col
            cols="12"
            sm="2"
            md="2"
            class="no-padding align-middle flex-center"
          >
            <div class="match-date">
              <span class="time">
                {{
                  new Date(object.event.scheduled).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                  })
                }}
              </span>
              <span class="day">{{ object.event.day }}</span>
              <span
                v-if="
                  getUserType == 4 ||
                  getCashier ||
                  !getSettings.enableQuickBetOnlyForAgency
                "
                class="event-qbet"
                title="qbet"
              >
                {{ object.event.quickbet }}
              </span>
            </div>
          </v-col>

          <v-col
            cols="12"
            sm="5"
            md="5"
            class="no-padding align-middle flex-start"
          >
            <div class="competitor away">
              <div class="name">{{ object.event.competitors.away.name }}</div>
              <!--              <div class="flag" :title="object.event.competitors.away.name">-->
              <!--                <img :src="flagTeamsPath+object.event.competitors.away.id+'.png'"-->
              <!--                     :alt="object.event.competitors.away.name">-->
              <!--              </div>-->
            </div>
          </v-col>
        </v-row>

        <v-row
          class="event-card-intro no-padding no-margin"
          :style="'background: #3a3a3a;height: 110px;'"
          v-else-if="object.event.type == 'antepost'"
        >
          <v-col cols="12" md="12" class="no-padding align-middle flex-center">
            <div class="match-date">
              <span class="time"> Antepost {{ object.tournament.name }} </span>
              <span class="day">
                {{ object.sport.name }} - {{ object.category.name }}
              </span>
            </div>
          </v-col>
        </v-row>
      </section>
      <section v-if="bannerMatchEventDetail === 'team-logo'">
        <v-row
          class="event-card-intro bannerv2 no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundPathV2 +
            object.sport.id +
            '.webp\')'
          "
          v-if="object.event.type == 'match'"
        >
          <v-col
            class="bg-transparent no-padding flex"
            cols="12"
            sm="12"
            md="12"
          >
            <v-col
              cols="12"
              sm="5"
              md="5"
              class="no-padding align-middle flex-end competitor-widget-home"
            >
              <div class="competitor home">
                <div class="logo-home">
                  {{ getLogoCompetitor(object.event.competitors.home.name) }}
                </div>

                <div class="name">{{ object.event.competitors.home.name }}</div>
              </div>
            </v-col>

            <v-col
              cols="12"
              sm="2"
              md="2"
              class="no-padding align-middle flex-center"
            >
              <div class="match-date">
                <span class="versus"> VS </span>
                <span class="time"
                  >{{ object.event.day }} ,
                  {{
                    new Date(object.event.scheduled).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                  }}</span
                >
                <span
                  v-if="
                    getUserType == 4 ||
                    getCashier ||
                    !getSettings.enableQuickBetOnlyForAgency
                  "
                  class="event-qbet"
                  title="qbet"
                >
                  {{ object.event.quickbet }}
                </span>
              </div>
            </v-col>

            <v-col
              cols="12"
              sm="5"
              md="5"
              class="no-padding align-middle flex-start competitor-widget-away"
            >
              <div class="competitor away">
                <div class="logo-away">
                  {{ getLogoCompetitor(object.event.competitors.away.name) }}
                </div>

                <div class="name">{{ object.event.competitors.away.name }}</div>
                <!--              <div class="flag" :title="object.event.competitors.away.name">-->
                <!--                <img :src="flagTeamsPath+object.event.competitors.away.id+'.png'"-->
                <!--                     :alt="object.event.competitors.away.name">-->
                <!--              </div>-->
              </div>
            </v-col>
          </v-col>
        </v-row>

        <v-row
          class="event-card-intro no-padding no-margin"
          :style="'background: #3a3a3a;height: 110px;'"
          v-else-if="object.event.type == 'antepost'"
        >
          <v-col cols="12" md="12" class="no-padding align-middle flex-center">
            <div class="match-date">
              <span class="time"> Antepost {{ object.tournament.name }} </span>
              <span class="day">
                {{ object.sport.name }} - {{ object.category.name }}
              </span>
            </div>
          </v-col>
        </v-row>
      </section>
    </section>
    <section v-if="mobile">
      <section v-if="bannerMatchEventDetail === 'default'">
        <v-row
          class="event-card-intro no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundPath +
            object.sport.id +
            '.webp\');background-position: bottom;'
          "
          v-if="object.event.type == 'match'"
          style="height: 70px"
        >
          <v-col
            xs="2"
            class="align-middle container-competitor"
            style="justify-content: center"
          >
            <div class="competitor">
              <!--              <div class="flag" :title="object.event.competitors.home.name">-->
              <!--                <img :src="flagTeamsPath+object.event.competitors.home.id+'.png'"-->
              <!--                     :alt="object.event.competitors.home.name">-->
              <!--              </div>-->
              <div class="name">{{ object.event.competitors.home.name }}</div>
            </div>
          </v-col>

          <v-col
            xs="8"
            class="align-middle flex-center"
            style="padding: 8px !important; height: 70px"
          >
            <div class="match-date">
              <span class="time">
                {{
                  new Date(object.event.scheduled).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                  })
                }}
              </span>
              <span class="day">{{ object.event.day }}</span>
            </div>
          </v-col>

          <v-col
            xs="2"
            class="align-middle flex-center"
            style="padding: 8px !important; height: 70px"
          >
            <div class="competitor away">
              <!--              <div class="flag" :title="object.event.competitors.away.name">-->
              <!--                <img :src="flagTeamsPath+object.event.competitors.away.id+'.png'"-->
              <!--                     :alt="object.event.competitors.away.name">-->
              <!--              </div>-->
              <div class="name">{{ object.event.competitors.away.name }}</div>
            </div>
          </v-col>
        </v-row>
        <v-row
          class="event-card-intro no-padding no-margin"
          :style="'background: #3a3a3a;height: 110px;'"
          v-else-if="object.event.type == 'antepost'"
        >
          <v-col cols="12" md="12" class="no-padding align-middle flex-center">
            <div class="match-date">
              <span class="time"> Antepost {{ object.tournament.name }} </span>
              <span class="day">
                {{ object.sport.name }} - {{ object.category.name }}
              </span>
            </div>
          </v-col>
        </v-row>
      </section>
      <section v-if="bannerMatchEventDetail === 'team-logo'">
        <v-row
          class="event-card-intro bannerv2 mobile no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundPathV2 +
            object.sport.id +
            '.webp\');background-position: bottom;'
          "
          v-if="object.event.type == 'match'"
          style="height: 150px"
        >
          <v-col cols="12" xs="12" class="bg-transparent no-padding flex">
            <v-col
              xs="2"
              class="align-middle container-competitor competitor-widget-home"
              style="padding: 8px !important; height: 150px"
            >
              <div class="competitor home">
                <div class="logo-home">
                  {{ getLogoCompetitor(object.event.competitors.home.name) }}
                </div>

                <div class="name">{{ object.event.competitors.home.name }}</div>
              </div>
            </v-col>

            <v-col
              xs="8"
              class="align-middle flex-center"
              style="padding: 8px !important; height: 150px"
            >
              <div class="match-date">
                <span class="versus"> VS </span>
                <span class="time"
                  >{{ object.event.day }} ,
                  {{
                    new Date(object.event.scheduled).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                  }}</span
                >
                <span
                  v-if="
                    getUserType == 4 ||
                    getCashier ||
                    !getSettings.enableQuickBetOnlyForAgency
                  "
                  class="event-qbet"
                  title="qbet"
                >
                  {{ object.event.quickbet }}
                </span>
              </div>
            </v-col>

            <v-col
              xs="2"
              class="align-middle flex-center competitor-widget-away"
              style="padding: 8px !important; height: 150px"
            >
              <div class="competitor away">
                <div class="logo-away">
                  {{ getLogoCompetitor(object.event.competitors.away.name) }}
                </div>

                <div class="name">{{ object.event.competitors.away.name }}</div>
              </div>
            </v-col>
          </v-col>
        </v-row>
        <v-row
          class="event-card-intro no-padding no-margin"
          :style="'background: #3a3a3a;height: 110px;'"
          v-else-if="object.event.type == 'antepost'"
        >
          <v-col cols="12" md="12" class="no-padding align-middle flex-center">
            <div class="match-date">
              <span class="time"> Antepost {{ object.tournament.name }} </span>
              <span class="day">
                {{ object.sport.name }} - {{ object.category.name }}
              </span>
            </div>
          </v-col>
        </v-row>
      </section>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '@/plugins/device-inspector'

export default {
  name: 'EventCardIntroBanner',
  data: () => ({
    modal: false,
    sportBackgroundPath:
      'https://rocky-revenge.s3.eu-west-1.amazonaws.com/svg/sports-bg/',
    sportBackgroundPathV2:
      'https://rocky-revenge.s3.eu-west-1.amazonaws.com/svg/bgsport-detail/',
  }),
  mounted() {
    console.log('[EventCardIntroBanner]', this.object)
  },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    live: {
      type: Boolean,
      default: false,
    },
    object: {
      type: Object,
      default: {},
    },
  },
  computed: {
    ...mapGetters({
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
      bannerMatchEventDetail: 'uiConfig/bannerMatchEventDetail',
    }),
  },
  methods: {
    ...mapActions({}),
    getLogoCompetitor(str) {
      // Remove spaces
      str = str.replace(/[^a-zA-Z0-9 ]/g, '').trim()

      if (str.includes(' ')) {
        // If there are spaces, return the first letters of each word
        return str
          .split(' ')
          .map(word => word[0])
          .join('')
      } else {
        // If there are no spaces, return the first three letters
        return str.slice(0, 3)
      }
    },

    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
  },
}
</script>

<style></style>
